import { Box } from '@mui/material'
import { DateTime } from 'luxon'

import { LUXON_HUMAN_TIME_FORMAT } from 'constants/formatting'
import { ShiftEvent } from 'types/tutoringShifts.types'

/**
 * A tiny "today only" mark on its own line under a card's hours when the TA moved them for this
 * day only in TA Draft; nothing otherwise.  Its title gives the usual hours.
 */
export const TodayOnlyHours = ({
  event,
  fontSize = '0.8vw',
  align = 'center',
}: {
  event?: Partial<ShiftEvent>
  fontSize?: string
  align?: 'center' | 'left'
}) => {
  const usual = event?.usual
  if (!usual) return null

  const format = (iso: string) => DateTime.fromISO(iso).toFormat(LUXON_HUMAN_TIME_FORMAT)
  return (
    <Box
      component="span"
      title={`Today only. Usually ${format(usual.startISO)} - ${format(usual.endISO)}`}
      sx={{
        display: 'block',
        width: 'fit-content',
        mx: align === 'center' ? 'auto' : 0,
        mt: '0.3em',
        px: '0.5em',
        py: '0.1em',
        borderRadius: '0.3em',
        border: '1px solid currentColor',
        color: 'text.secondary',
        fontSize,
        fontWeight: 700,
        letterSpacing: '0.05em',
        whiteSpace: 'nowrap',
      }}
    >
      TODAY ONLY
    </Box>
  )
}
